module.exports = function(condition) {
    return (condition) ? "checked" : "";
};
